/**
 * 银行交易明细
 */
import React from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { XInput, XOKButton, XCancelButton, XSelect, XDatePicker } from '@/components/xqxc_ui';
import { connect } from 'react-redux';
import TableList from './components/TableList';
import model from '@/reducers/finance/banktransaction/model';
import KeepAlive from '@/routes/KeepAlive';
import { SearchBox, SearchItem } from '@/components/Layout';
import { autoPageNum, autopageSize } from '@/assets/config';

class Main extends React.Component {

    state = {
        orderNo: '',
        otherAcctName: '',
        incomeOutType: {},
        transactionName: {},
        startTime: undefined,
        endTime: undefined,
        pageNum: 1,
        pageSize: 10,
    }

    componentDidMount() {
        this.props.getIncomeDrawTypeList({ enumName: 'UnionWalletLoanMarkEnum' });
        this.props.getTransactionNameList({ enumName: 'UnionWalletTransNameEnum' });
    }

    // 查询
    _searchHandle = (useCache) => {
        const { orderNo, otherAcctName, incomeOutType, transactionName, startTime, endTime, pageNum, pageSize } = this.state;
        this.searchCache = {
            orderNo,
            otherAcctName,
            loanMark: incomeOutType.code,
            transCode: transactionName.code,
            startTime,
            endTime,
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        this.props.getTransactionList(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageNum: this.searchCache.pageNum, pageSize: this.searchCache.pageSize }); // 【第3步，缓存查询状态】
    }

    // 重置
    _resetHandle = () => {
        this.setState({ orderNo: '', otherAcctName: '', incomeOutType: {}, transactionName: {}, startTime: undefined, endTime: undefined, pageNum: 1, pageSize: 10 }, () => {
            KeepAlive.saveResetFunc(this._searchHandle); // 【第4步：将是否调用重置交给KeepAlive控制】
        });
    }

    // 表格分页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageNum, pageSize }, () => {
            this._searchHandle('useCache');
        });
    }

    render() {
        const { orderNo, otherAcctName, incomeOutType, transactionName, startTime, endTime } = this.state;
        const { transactionList, incomeDrawTypeList, transactionNameList } = this.props;
        return (
            <KeepAlive render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <SearchBox>
                        <SearchItem>
                            <XInput
                                inputStyle={{ width: '330px' }}
                                label='订单号'
                                placeholder='请输入'
                                value={orderNo}
                                bindThis={this}
                                bindName='orderNo'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XInput
                                inputStyle={{ width: '150px' }}
                                label='对方账户名'
                                placeholder='请输入'
                                value={otherAcctName}
                                bindThis={this}
                                bindName='otherAcctName'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                selectStyle={{ width: '150px' }}
                                label='交易名称'
                                placeholder='请选择'
                                renderData={transactionNameList}
                                dataIndex='value'
                                keyIndex='code'
                                value={transactionName.value}
                                bindThis={this}
                                bindName='transactionName'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                selectStyle={{ width: '150px' }}
                                label='收支方式'
                                placeholder='请选择'
                                renderData={incomeDrawTypeList}
                                dataIndex='value'
                                keyIndex='code'
                                value={incomeOutType.value}
                                bindThis={this}
                                bindName='incomeOutType'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XDatePicker
                                label='所得时间'
                                datePickerStyle={{ width: 200 }}
                                value={startTime}
                                bindThis={this}
                                bindName='startTime'
                                isFormat
                            />
                            <XDatePicker
                                style={{ marginRight: 20 }}
                                datePickerStyle={{ width: 200 }}
                                label=''
                                value={endTime}
                                bindThis={this}
                                bindName='endTime'
                                isFormat
                            />
                        </SearchItem>
                        <SearchItem>
                            <XOKButton
                                style={{ marginLeft: '20px', width: '60px' }}
                                label='查询'
                                onClick={this._searchHandle}
                            />
                            <XCancelButton
                                style={{ marginLeft: '20px', width: '60px' }}
                                label='重置'
                                onClick={this._resetHandle}
                            />
                        </SearchItem>
                    </SearchBox>
                    <TableList renderData={transactionList} paginationChange={this._paginationChange} />
                </div>
            </KeepAlive>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object,

    getTransactionList: PropTypes.func,
    transactionList: PropTypes.object,

    getIncomeDrawTypeList: PropTypes.func,
    incomeDrawTypeList: PropTypes.array,

    getTransactionNameList: PropTypes.func,
    transactionNameList: PropTypes.array,
};
const mapStateToProps = (state) => ({
    incomeDrawTypeList: state.banktransaction.incomeDrawTypeList,
    transactionNameList: state.banktransaction.transactionNameList,
    transactionList: state.banktransaction.transactionList,
});

export default connect(mapStateToProps, { ...model.actions })(Main);